export const decisionsConfig = {
  name: '决策管理',
  description: '有方法、有依据地做选择，实现最佳结果',
  icon: 'CheckCircleOutlined',
  bgColor: '#13C2C2',
  iconColor: '#FFFFFF',
  
  // API端点
  apiEndpoints: {
    decisions: '/decisions',
    createDecision: '/decisions',
    updateDecision: '/decisions',
    deleteDecision: '/decisions',
    types: '/decisions/types',
    createType: '/decisions/types',
    updateType: '/decisions/types',
    deleteType: '/decisions/types',
    stats: '/decisions/stats'
  },

  // 决策类型定义
  decisionTypes: [
    {
      key: 'personal',
      name: '个人决策',
      icon: '👤',
      color: '#1890FF',
      description: '个人生活、职业、健康等决策'
    },
    {
      key: 'business',
      name: '商业决策',
      icon: '💼',
      color: '#52C41A',
      description: '企业经营、市场策略、投资等决策'
    },
    {
      key: 'project',
      name: '项目决策',
      icon: '📋',
      color: '#FAAD14',
      description: '项目规划、资源配置、技术选择等决策'
    },
    {
      key: 'financial',
      name: '财务决策',
      icon: '💰',
      color: '#722ED1',
      description: '投资理财、成本控制、预算分配等决策'
    },
    {
      key: 'strategic',
      name: '战略决策',
      icon: '🎯',
      color: '#F5222D',
      description: '长期规划、发展方向、重大变革等决策'
    },
    {
      key: 'operational',
      name: '运营决策',
      icon: '⚙️',
      color: '#13C2C2',
      description: '日常运营、流程优化、效率提升等决策'
    }
  ],

  // 决策状态
  decisionStatus: [
    { key: 'pending', name: '待决策', color: 'orange' },
    { key: 'analyzing', name: '分析中', color: 'blue' },
    { key: 'decided', name: '已决策', color: 'green' },
    { key: 'implementing', name: '实施中', color: 'purple' },
    { key: 'completed', name: '已完成', color: 'success' },
    { key: 'cancelled', name: '已取消', color: 'default' }
  ],

  // 优先级
  priorities: [
    { key: 'high', name: '高', color: 'red' },
    { key: 'medium', name: '中', color: 'orange' },
    { key: 'low', name: '低', color: 'green' }
  ],

  // 决策管理TIPS
  decisionManagementTips: {
    title: '决策管理核心步骤',
    description: '有目标、有数据、有分析、有流程地做选择',
    steps: [
      {
        step: 1,
        title: '明确目标',
        icon: '🎯',
        description: '决策前先清楚想要达到的结果',
        details: '设定明确、可衡量、可实现的目标，确保决策方向正确',
        examples: [
          '公司决策目标是"降低成本10%"',
          '个人决策目标是"提高工作效率20%"',
          '项目决策目标是"按时完成并控制预算"'
        ]
      },
      {
        step: 2,
        title: '收集信息',
        icon: '📊',
        description: '收集相关数据、历史经验、市场情况、风险因素',
        details: '全面收集决策所需的各种信息和数据',
        examples: [
          '财务报表和市场调研数据',
          '历史经验和专家意见',
          '竞争对手分析和风险评估'
        ]
      },
      {
        step: 3,
        title: '分析方案',
        icon: '🔍',
        description: '对比不同方案的优缺点、成本、风险和收益',
        details: '使用科学方法分析各种可能方案',
        examples: [
          'SWOT分析（优势、劣势、机会、威胁）',
          '成本效益分析',
          '决策树和风险评估'
        ]
      },
      {
        step: 4,
        title: '做出选择',
        icon: '✅',
        description: '根据分析结果，选择最优或最可行方案',
        details: '基于分析结果做出最终决策',
        examples: [
          '选择成本效益最高的方案',
          '选择风险可控且收益可观的方案',
          '选择最符合长期战略的方案'
        ]
      },
      {
        step: 5,
        title: '实施与监控',
        icon: '🛠️',
        description: '将决策方案落地，并持续跟踪效果',
        details: '制定实施计划并监控执行效果',
        examples: [
          '制定详细的实施计划和时间表',
          '建立监控机制和关键指标',
          '定期检查实施进度和效果'
        ]
      },
      {
        step: 6,
        title: '复盘与改进',
        icon: '🔄',
        description: '总结经验，优化决策流程，为下一次决策提供参考',
        details: '分析决策效果，总结经验教训',
        examples: [
          '分析决策成功或失败的原因',
          '总结决策过程中的经验和教训',
          '优化决策流程和方法'
        ]
      }
    ]
  },

  // 决策分析方法
  decisionAnalysisMethods: {
    title: '常用决策分析方法',
    description: '科学的决策分析工具和方法',
    methods: [
      {
        name: 'SWOT分析',
        description: '分析优势、劣势、机会、威胁',
        icon: '📈',
        steps: [
          '识别内部优势（Strengths）',
          '识别内部劣势（Weaknesses）',
          '识别外部机会（Opportunities）',
          '识别外部威胁（Threats）'
        ]
      },
      {
        name: '成本效益分析',
        description: '对比方案的成本和收益',
        icon: '💰',
        steps: [
          '计算各方案的总成本',
          '估算各方案的预期收益',
          '计算投资回报率（ROI）',
          '考虑时间价值和风险因素'
        ]
      },
      {
        name: '决策树分析',
        description: '用树状图分析决策路径',
        icon: '🌳',
        steps: [
          '绘制决策节点和选择分支',
          '计算各路径的概率和收益',
          '计算期望值',
          '选择期望值最高的路径'
        ]
      },
      {
        name: '风险评估',
        description: '识别和评估决策风险',
        icon: '⚠️',
        steps: [
          '识别潜在风险因素',
          '评估风险发生的概率',
          '评估风险的影响程度',
          '制定风险应对策略'
        ]
      }
    ]
  },

  // 决策管理原则
  decisionManagementPrinciples: {
    title: '决策管理核心原则',
    description: '确保决策质量和效果的基本原则',
    principles: [
      {
        title: '目标导向',
        description: '所有决策都要围绕明确的目标进行',
        icon: '🎯'
      },
      {
        title: '数据驱动',
        description: '基于客观数据和事实做出决策',
        icon: '📊'
      },
      {
        title: '全面分析',
        description: '考虑所有相关因素和可能影响',
        icon: '🔍'
      },
      {
        title: '风险可控',
        description: '在可接受的风险范围内做出决策',
        icon: '🛡️'
      },
      {
        title: '持续改进',
        description: '不断优化决策流程和方法',
        icon: '🔄'
      }
    ]
  },

  // 决策管理应用场景
  decisionManagementScenarios: {
    title: '决策管理应用场景',
    description: '决策管理在不同领域的应用',
    scenarios: [
      {
        title: '个人生活',
        description: '买房买车、职业选择、健康管理',
        icon: '👤',
        examples: [
          '购房决策：位置、价格、户型、投资价值',
          '职业选择：兴趣、能力、发展前景、薪资',
          '健康管理：运动方式、饮食习惯、医疗选择'
        ]
      },
      {
        title: '企业管理',
        description: '市场策略、产品研发、投资决策',
        icon: '💼',
        examples: [
          '市场策略：目标市场、营销方式、竞争策略',
          '产品研发：技术路线、资源配置、时间安排',
          '投资决策：项目选择、资金分配、风险控制'
        ]
      },
      {
        title: '政府管理',
        description: '公共政策制定、资源分配、应急决策',
        icon: '🏛️',
        examples: [
          '公共政策：政策目标、实施方案、效果评估',
          '资源分配：预算分配、项目优先级、资源配置',
          '应急决策：危机应对、资源调配、信息发布'
        ]
      }
    ]
  }
};
